import { useMutate } from '@/shared/hooks/useMutate';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiSplitSave } from '@/entities/splits/modules/api/splits';
import type { ApiSplitsSavePostBody } from '@/shared/types/api/splits';

export const useSetSplitTargets = (id: string) =>
  useMutate({
    api: (body: ApiSplitsSavePostBody) => apiSplitSave(id, body),
    invalidateKeys: [queryKeys.splits.detail(id), queryKeys.splits.all],
  });
